export default [
    {
        "id": "wishlist",
        "html": require('./wishlist/html').default,
        "css": require('./wishlist/css').default,
        "cssTablet": require('./wishlist/cssTablet').default,
        "cssMobile": require('./wishlist/cssMobile').default,
        "scss": require('./wishlist/scss').default,
        "scssTablet": require('./wishlist/scssTablet').default,
        "scssMobile": require('./wishlist/scssMobile').default
    }
]